import { Modal, QRCode, message } from "antd";
import style from "./wxpay.module.scss";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import wxLogo from "../../assets/img/wxlogo.png";
import aliLogo from "../../assets/img/zhifubao.png";
import unionLogo from "../../assets/img/yinlian.png";
import { queryPayStatus } from "../../api/order";
import { PayResultStatus, PayWay } from "../../utils/contants";
import { useNavigate } from "react-router";
import "./modal.scss";
import { useRecoilValue } from "recoil";
import { buyJournalMoneySelector, isBuyJournalSelector } from "@/store/order";
import { math } from "@/utils/math";

type Data = {
  url: string;
  money: number;
  transaction_id: string;
};

export type Props = {
  way: PayWay;
  value: Data;

  confirm: () => void;
  cancel?: () => void;
};

const qrTitle: Partial<Record<PayWay, string>> = {
  [PayWay.Wx]: "微信支付二维码",
  [PayWay.Zhifubao]: "支付宝支付二维码",
  [PayWay.Yinlian]: "银联云闪付二维码",
};

const qrLogo: Partial<Record<PayWay, string>> = {
  [PayWay.Wx]: wxLogo,
  [PayWay.Zhifubao]: aliLogo,
  [PayWay.Yinlian]: unionLogo,
};

const WxPay = (props: Props) => {
  const { value, way } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const time = useRef<ReturnType<typeof setTimeout>>();
  const navigate = useNavigate();
  const [modalApi, contextModalHolder] = Modal.useModal();
  const checkedBuyStore = useRecoilValue(isBuyJournalSelector);
  const buyMoneyStore = useRecoilValue(buyJournalMoneySelector);
  const confirm = async () => {
    setOpen(false);
    props.confirm();
    const result = await pollingStatus();
    if (result && result === PayResultStatus.UnDone) {
      navigate("/result?transaction_id=" + value.transaction_id);
    }
  };
  const totalPrice = useMemo(() => {
    if (!checkedBuyStore) return value.money.toFixed(2);
    return math.add(value.money, buyMoneyStore).toFixed(2);
  }, [value, checkedBuyStore, buyMoneyStore]);

  const cancel = () => {
    setOpen(false);
    props.cancel?.();
  };

  /**
   * 查询支付状态
   * @returns
   */
  const pollingStatus = async () => {
    const res = await queryPayStatus<{ pay_status }>({
      transaction_id: value.transaction_id,
    });
    if (res.code === 0) {
      switch (res.data.pay_status) {
        // 交易完成
        case PayResultStatus.Completed:
          clearInterval(time.current);
          navigate("/result?transaction_id=" + value.transaction_id);
          break;
        // 交易失败
        case PayResultStatus.Failed:
          clearInterval(time.current);
          modalApi.error({
            centered: true,
            title: t("支付遇到错误"),
            content: res.msg,
            okText: t("重新支付"),
            onOk() {
              location.reload();
            },
          });
          break;
        default:
          break;
      }
      return res.data.pay_status;
    } else {
      clearInterval(time.current);

      modalApi.error({
        centered: true,
        title: t("支付遇到错误"),
        content: res.msg,
        okText: t("重新支付"),
        onOk() {
          location.reload();
        },
      });
    }
  };

  useEffect(() => {
    time.current = setInterval(pollingStatus, 1000);
    return () => {
      clearInterval(time.current);
    };
  }, []);

  return (
    <Modal
      onCancel={cancel}
      //   okText={t("已完成付款")}
      //   cancelText={t("选择其他支付方式")}
      //   onOk={confirm}
      open={open}
      title={t(qrTitle[way] || "微信支付二维码")}
      width={640}
      footer={
        <>
          <button className="cancel" onClick={cancel}>
            {t("选择其他支付方式")}
          </button>
          <button className="done" onClick={confirm}>
            {t("已完成付款")}
          </button>
        </>
      }
      wrapClassName="modal-wrapper"
    >
      {contextModalHolder}
      <div className={style.qrcodeBox}>
        <div className={style.content}>
          <div className={style.qrcode}>
            <QRCode value={value.url} size={148} bordered={false} />
            {qrLogo[way] && (
              <img className={style.payLogo} src={qrLogo[way]} alt="" />
            )}
          </div>
          <div className={style.moneyBox}>
            <span>{t("交易金额")}</span>
            <span>¥</span>
            <span>{totalPrice}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WxPay;
